import { isDate, isObject, isPromise, isString } from 'radash';

import { isSyncResult, Success, SyncResult } from './SyncResult';

export const idle = 'Idle';

export interface SyncState {
  asOf: Date;
  description: string;
}

export interface InProgress extends SyncState {
  start: Date;
  promise: Promise<Success>;
}

export interface Done extends SyncState {
  description: typeof idle;
  result: SyncResult;
}

export function isSyncState(obj: unknown): obj is SyncState {
  if (!isObject(obj)) return false;
  const possible = obj as Partial<SyncState>;
  if (!isString(possible.description)) return false;
  if (!isDate(possible.asOf)) return false;
  return true;
}

export function isDone(obj: unknown): obj is Done {
  if (!isSyncState(obj)) return false;
  if (obj.description !== idle) return false;
  const possible = obj as Partial<Done>;
  if (!isSyncResult(possible.result)) return false;
  return true;
}

export function isInProgress(obj: unknown): obj is InProgress {
  if (!isSyncState(obj)) return false;
  const possible = obj as Partial<InProgress>;
  if (!isString(possible.description)) return false;
  if (!isDate(possible.start)) return false;
  return isPromise(possible.promise);
}
